export {default} from '../../../core/components/AppMenu/AppMenuItems';
